import { DEFAULT_WINNIN_LOGO_CAPTION } from './chart-export.consts'

export const buildCaptionHtml = (captionLeft?: string): string => {
  if (!captionLeft) return DEFAULT_WINNIN_LOGO_CAPTION
  return `<div style="display:flex;align-items:center"><span>${captionLeft}</span>${DEFAULT_WINNIN_LOGO_CAPTION.trim()}</div>`
}

export const getExportOptions = (title: string, dataUniverse?: string) => ({
  filename: title,
  title: { text: title },
  ...(dataUniverse && {
    subtitle: { text: `Data universe: ${dataUniverse}` },
  }),
  caption: {
    text: DEFAULT_WINNIN_LOGO_CAPTION,
  },
})
